<script>
	export default{
		data(){
			return {
				users: [
					{userid:'A0N00PC' ,nombre: 'Andres',apellidos: 'Nader'},
					{userid:'AAI000G' ,nombre: 'Alejandra Itzel',apellidos: 'Gonzalez'},
					{userid:'ELEIVA1' ,nombre: 'Elainy',apellidos: 'Leiva'},
					{userid:'FFP0005' ,nombre: 'Franz Paul',apellidos: 'Pfeiffer'},
					{userid:'HAR000Q' ,nombre: 'Hudson Alexandre',apellidos: 'Rodrigues'},
					{userid:'JRODR72' ,nombre: 'Jose',apellidos: 'Rodriguez'},
					{userid:'KMR0016' ,nombre: 'Karla',apellidos: 'Ramirez'},
					{userid:'MAPARDO' ,nombre: 'Alejandro',apellidos: 'Pardo Diaz'},
					{userid:'MC1EVIL' ,nombre: 'Christian Eduardo',apellidos: 'Villa Y'},
					{userid:'MCGONZ1' ,nombre: 'Carlos Miguel',apellidos: 'Gonzalez'},
				]
			}
		},
		mounted(){
			
		},
		methods:{
			selectDMM(dmm){
				this.$emit('setDMM',dmm);
				window.$('#dmm-modal').modal('hide');
			}
		}
	}

</script>
<template>
	<div id="dmm-modal" class="modal fade modal-second" role="dialog">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="header-modal">
					<label>Búsqueda: Identificación de usuario de aprobador</label>
					<div class="modal-header-buttons">
						<button type="button">
							<i class="far fa-window-maximize"></i>	
						</button>
						<button type="button" data-dismiss="modal" >
							<i class="fas fa-times"></i>	
						</button>
					</div>
				</div>
				<div class="body-modal pb-30">
					<table class="table-first-gray table-row-hover">
						<tr>
							<td></td>
							<td>User ID</td>
							<td>Nombre pila</td>
							<td>Apellido</td>
						</tr>
						<tr v-for="(user,index) in users" :key="index" @click="selectDMM(user)">
							<td></td>
							<td>{{user.userid}}</td>
							<td>{{user.nombre}}</td>
							<td>{{user.apellidos}}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>